import { render, staticRenderFns } from "./NLP.vue?vue&type=template&id=280bf780"
import script from "./NLP.vue?vue&type=script&lang=js"
export * from "./NLP.vue?vue&type=script&lang=js"
import style0 from "./NLP.vue?vue&type=style&index=0&id=280bf780&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports